import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../api";
import { haptics } from "../haptics";
import { useToast } from "../../contexts/ToastContext";
import { PendingOut } from "../schemas";

export function useReceiptCancelMutation() {
  const qc = useQueryClient();
  const showToast = useToast();

  return useMutation({
    mutationFn: ({ chatId, receiptId }: { chatId: number; receiptId: string; token?: string }) =>
      api("POST", `/chats/${chatId}/receipts/${receiptId}/cancel`),

    onMutate: async ({ token }) => {
      haptics.warning();
      if (!token) return { snapshots: [] };
      await qc.cancelQueries({ queryKey: ["pending"] });
      const snapshots = qc.getQueriesData<PendingOut[]>({ queryKey: ["pending"] });
      for (const [key, data] of snapshots) {
        if (data) qc.setQueryData(key, data.filter((p) => p.token !== token));
      }
      return { snapshots };
    },

    onError: (err, _vars, ctx) => {
      ctx?.snapshots.forEach(([key, data]) => qc.setQueryData(key, data));
      showToast(err instanceof Error ? err.message : "Cancel failed", { type: "error" });
    },

    onSuccess: () => {
      showToast("Receipt cancelled", { type: "info" });
    },

    onSettled: (_data, _err, { receiptId }) => {
      void qc.invalidateQueries({ queryKey: ["pending"] });
      void qc.invalidateQueries({ queryKey: ["receipt", receiptId] });
      void qc.invalidateQueries({ queryKey: ["history"] });
      void qc.invalidateQueries({ queryKey: ["group"] });
      void qc.invalidateQueries({ queryKey: ["balances"] });
    },
  });
}
